var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style[`cc-side-effect-consult`]},[(_vm.openChatRoom)?_c('div',{class:_vm.$style[`cc-side-effect-consult-wrap`]},[_c('EffectChatRoom',{attrs:{"indexOverview":false,"showProfile":false,"activated":true,"startLoad":true}})],1):_c('div',{class:_vm.$style[`cc-side-effect-consult-wrap`]},[_c('EffectConsultVendor')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }